export enum FieldsId {
  CTC = '__BVID__17',
  VU = '__BVID__29',
  UIN = '__BVID__41',
  INN = '__BVID__99',
  PLATE_NUM = '__BVID__21',
  PLATE_REG = '__BVID__22',
  PASPORT = '__BVID__01'
}
